import { useContext } from "react";
import { ServerErrorContext } from "@/contexts/ServerErrorContext.context";

export function useServerError() {
  const context = useContext(ServerErrorContext);
  if (!context) {
    throw new Error("useServerError must be used within a ServerErrorProvider");
  }
  return context;
}